// import React, { Suspense, useEffect } from "react";
// import {
//   Routes,
//   Route,
//   useLocation,
//   useNavigate
// } from 'react-router-dom';
// import viewsUrls from "./routes";

// function Routers(props: any) {

//   return (
//       <Routes>
//         {
//           viewsUrls?.map(({ component, path, exact, type, id}: any) => {
//             let Component = component;
//             return (
//               <Route 
//                 key={id}
//                 path={path} 
//                 element = { <Component /> } 
//               />
//             );
//           })
//         }
//        {/* <Route path="/404" element = { <ErrorPage />} /> */}
//       </Routes>
//   );
// }

// export default Routers;

import { Routes, Route } from "react-router-dom"
import viewsUrls from "./routes"
import ProtectedRoute from "./ProtectedRoute"
import { PublicLayout } from "../layouts/PublicLayout"
import { PrivateLayout } from "../layouts/PrivateLayout"


function Routers() {
  return (
    <Routes>
      {viewsUrls.map(({ id, path, component: Component, type }) => {
        if (type === "public") {
          return (
            <Route
              key={id}
              path={path}
              element={
                <PublicLayout>
                  <Component />
                </PublicLayout>
              }
            />
          )
        }

        return (
          <Route
            key={id}
            path={path}
            element={
              <ProtectedRoute>
                <PrivateLayout>
                  <Component />
                </PrivateLayout>
              </ProtectedRoute>
            }
          />
        )
      })}
    </Routes>
  )
}

export default Routers;